import { render, staticRenderFns } from "./publish-log.vue?vue&type=template&id=7a4b6148&scoped=true"
import script from "./publish-log.vue?vue&type=script&lang=js"
export * from "./publish-log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4b6148",
  null
  
)

export default component.exports